import React from 'react'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import BodyText from 'components/Luxkit/Typography/BodyText'
import styled from 'styled-components'
import { rem } from 'polished'
import { useTranslation } from 'react-i18next'

const Stack = styled.div`
  & > * + * {
    margin-top: ${rem(8)}
  }

  &.md {
    & > * + * {
      margin-top: ${rem(12)}
    }
  }
`

interface Props {
  bonusInclusions?: string;
  inclusions?: string;
  size?: 'small' | 'medium' | 'large';
}

export const InclusionsSection = ({ bonusInclusions, inclusions, size = 'medium' }: Props) => {
  const { t } = useTranslation('offerPage')

  return <Stack className="md">
    {bonusInclusions &&
      <Stack>
        <BodyText variant={size} weight="bold">{t('BONUS inclusions', { ns: 'offerPage' })}:</BodyText>
        <MarkdownRender
          fontSize={size}
          type="compact"
          content={bonusInclusions}
        />
      </Stack>
    }
    {inclusions && <div>
      {bonusInclusions && <BodyText variant={size} weight="bold">{t('extraInclusionsHeading', { ns: 'offerPage' })}</BodyText>}
      <MarkdownRender fontSize={size} type="compact" content={inclusions} />
    </div>}
  </Stack>
}
